import { z } from 'zod';
import { getMonthToDateRange } from '@/utils/date';

export const optionalPositiveIdSchema = z.coerce
  .number()
  .int()
  .positive()
  .optional()
  .catch(undefined);

export const optionalTextSchema = z.string().optional().catch(undefined);

export const optionalDateSchema = z.iso.date().optional().catch(undefined);

export const monthStartDateSchema = z.iso.date().catch(() => getMonthToDateRange().dateFrom);

export const todayDateSchema = z.iso.date().catch(() => getMonthToDateRange().dateTo);
